<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const { $containment } = useNuxtApp();
const { isAuthenticated } = storeToRefs(useAuthStore());
const { modalType } = storeToRefs(useLayoutStore());
const { closeModal } = useLayoutStore();
const { openLogin } = useAuth();

const closeModalOrGoToLogin = () => {
  if (window.self !== window.top) {
    closeModal();
    window.parent.postMessage('closeModal');

    return;
  }

  navigateTo(localeLink('/'));
  openLogin();
};

watchEffect(() => {
  if (!isAuthenticated.value) {
    nextTick(() => {
      closeModalOrGoToLogin();
    });
  }
});

onMounted(() => {
  modalType.value = 'verification';
  window.parent.postMessage('iframeReady');
});

onBeforeMount(() => {
  $containment.fetchCurrentPending('global');
});
</script>

<template>
  <AuthPageLayout
    :show-logo="false"
    @action-to-close="closeModalOrGoToLogin"
  >
    <AuthVerification />
  </AuthPageLayout>
</template>
